import { Box, Button, Typography } from '@mui/material'
import { getServicePageFx } from '../../Api/PaidService/servicePage'
import React from 'react'
import { useParams } from 'react-router-dom'
import api from '../../Auth/api'

export const ReturnToWorkForm = ({
  callback
}: {
  callback: (...args: any) => any
}) => {
  const { id } = useParams()
  const returnToWorkFecth = React.useCallback(() => {
    api
      .put('paid-service/rollback-work', {
        id: Number(id)
      })
      .then(() => {
        getServicePageFx(Number(id))
      })
      .then(() => {
        callback && callback()
      })
  }, [id, callback])
  return (
    <Box>
      <Typography>Вы собираетесь вернуть в работу данную услугу</Typography>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" type={'submit'} onClick={returnToWorkFecth}>
          Подтвердить
        </Button>
      </Box>
    </Box>
  )
}
